export default {
  sid_signals_table: 7,
  highs_and_lows_table: 8,
  supply_and_demand_alerts_table: 11,
  supply_and_demand_table: 10,
  trend_strategy_signals_table: 9,
  insider_transactions_summary: 1,
  stocks_list: 2,
  desktop_stocks_list: 3,
  stock_quarterly_data: 4,
  financial_instruments_list: 5,
  desktop_stocks_list_tab: 13,
  ops_opd: 17
};
